import { render, staticRenderFns } from "./Impersonator.vue?vue&type=template&id=6a54f8d6&scoped=true&"
import script from "./Impersonator.vue?vue&type=script&lang=js&"
export * from "./Impersonator.vue?vue&type=script&lang=js&"
import style0 from "./Impersonator.vue?vue&type=style&index=0&id=6a54f8d6&prod&lang=scss&scoped=true&"
import style1 from "./Impersonator.vue?vue&type=style&index=1&id=6a54f8d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a54f8d6",
  null
  
)

export default component.exports